import styled from 'styled-components'

export const FiltersRoot = styled.form`
    margin-top: 12px;
    padding: 14px;
    border: 1px solid ${({ theme }) => theme.palette.colors.cardBorder};
    border-radius: 14px;
    background: ${({ theme }) => theme.palette.colors.controlSurface};
    .MuiInputLabel-root {
        color: ${({ theme }) => theme.palette.colors.muted};
        font-size: 17px;
    }
    .MuiSelect-select, input {
        font-size: 16px;
    }
`;
export const FilterGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(5, minmax(128px, 0.85fr)) minmax(220px, 1.5fr) auto;
    gap: 10px;
    align-items: end;
    @media (max-width: 1180px) { grid-template-columns: repeat(3, minmax(0, 1fr)); }
    @media (max-width: 760px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
    @media (max-width: 560px) { grid-template-columns: 1fr; }
`;
export const FilterField = styled.div`
    min-width: 0;
    ${({ $wide }) => $wide ? 'min-width: 200px;' : ''}
`;
export const FilterActions = styled.div`
    min-height: 48px;
    display: flex;
    align-items: center;
    @media (max-width: 980px) { justify-content: flex-start; }
`;
